<template>
  <div class="page-shell teacher-detail-page">
    <MobileTopNav
      v-if="isMobile"
      title="教师详情"
    />

    <main class="teacher-detail-main">
      <div class="teacher-detail-container">
        <div
          v-if="loading"
          class="teacher-detail-state"
        >
          加载中...
        </div>

        <div
          v-else-if="!teacher.id"
          class="teacher-detail-state"
        >
          暂无教师详情
        </div>

        <article
          v-else
          class="teacher-detail-card"
        >
          <h1>{{ teacher.name }}</h1>

          <div class="teacher-detail-photo">
            <img
              v-if="teacher.profile"
              :src="teacher.profile"
              :alt="teacher.name"
            >
            <div
              v-else
              class="teacher-detail-placeholder"
            >
              {{ teacher.name ? teacher.name.slice(0, 1) : '师' }}
            </div>
          </div>

          <p class="teacher-detail-info">{{ teacher.info }}</p>
        </article>
      </div>
    </main>
  </div>
</template>

<script>
import MobileTopNav from '../components/MobileTopNav.vue'
import { resolveTeacherImage } from '../utils/teacher'

function getTeacherResult(response) {
  if (response && response.result) {
    return response.result
  }

  if (response && response.data && response.data.result) {
    return response.data.result
  }

  return response || {}
}

export default {
  name: 'TeacherDetailView',
  components: {
    MobileTopNav
  },
  data() {
    return {
      loading: false,
      isMobile: false,
      teacher: {
        id: '',
        name: '',
        info: '',
        profile: '',
        sex: 0,
        updateTime: ''
      }
    }
  },
  computed: {
    teacherId() {
      return this.$route.params.id || this.$route.query.id || ''
    }
  },
  watch: {
    teacherId: {
      immediate: true,
      handler() {
        this.fetchTeacherDetail()
      }
    }
  },
  mounted() {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 768
    },
    async fetchTeacherDetail() {
      if (!this.teacherId) {
        this.teacher = {
          id: '',
          name: '',
          info: '',
          profile: '',
          sex: 0,
          updateTime: ''
        }
        document.title = '教师详情'
        return
      }

      this.loading = true

      try {
        const response = await this.$get('/teacher/selectById', {
          id: this.teacherId
        })
        const result = getTeacherResult(response)
        const name = result.name || '教师详情'

        this.teacher = {
          id: result.id || '',
          name,
          info: result.info || '',
          profile: resolveTeacherImage(result.profile),
          sex: result.sex || 0,
          updateTime: result.updateTime || ''
        }
        document.title = name
      } catch (error) {
        this.teacher = {
          id: '',
          name: '',
          info: '',
          profile: '',
          sex: 0,
          updateTime: ''
        }
        document.title = '教师详情'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.teacher-detail-page {
  min-height: 100vh;
  background: #fff;
}

.teacher-detail-main {
  width: 100%;
  min-height: 100vh;
}

.teacher-detail-container {
  width: 100%;
  padding: 28px 0 36px;
}

.teacher-detail-state {
  padding: 80px 20px;
  color: #9098a4;
  font-size: 16px;
  line-height: 1.6;
  text-align: center;
}

.teacher-detail-card {
  width: 100%;
  padding: 0 0 24px;
}

.teacher-detail-card h1 {
  padding: 0 20px;
  color: #2f2f2f;
  font-size: 32px;
  font-weight: 700;
  line-height: 1.4;
  text-align: center;
}

.teacher-detail-photo {
  width: 100%;
  max-width: 560px;
  margin: 28px auto 0;
  background: #e9edf7;
}

.teacher-detail-photo img {
  display: block;
  width: 100%;
  height: auto;
}

.teacher-detail-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1 / 1;
  background: linear-gradient(135deg, #fff4e8 0%, #ffe0c0 100%);
  color: #ff7d29;
  font-size: 108px;
  font-weight: 700;
}

.teacher-detail-info {
  width: 100%;
  max-width: 760px;
  margin: 24px auto 0;
  padding: 0 20px;
  color: #2f2f2f;
  font-size: 20px;
  line-height: 1.9;
  text-align: justify;
  white-space: pre-wrap;
  word-break: break-word;
}

@media (max-width: 768px) {
  .teacher-detail-main {
    min-height: calc(100vh - 48px);
  }

  .teacher-detail-container {
    padding-top: 16px;
    padding-bottom: 28px;
  }

  .teacher-detail-card h1 {
    padding: 0 16px;
    font-size: 22px;
  }

  .teacher-detail-photo {
    margin-top: 18px;
  }

  .teacher-detail-info {
    margin-top: 18px;
    padding: 0 16px;
    font-size: 17px;
    line-height: 1.85;
  }
}
</style>
